(function () {
    var chatHasEnded = false;
    
    function escapeBasicHtml(text) {
        if (text == null || text === undefined) return '';
        
        var str = String(text);
        
        str = str.replace(/&/g, '&amp;')
                 .replace(/</g, '&lt;')
                 .replace(/>/g, '&gt;')
                 .replace(/"/g, '&quot;')
                 .replace(/'/g, '&#39;');
        
        str = str.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, function(char) {
            var code = char.charCodeAt(0);
            return '\\x' + (code < 16 ? '0' : '') + code.toString(16);
        });
                
        return str;
    }

    function sanitizeUrl(url) {
        try {
            var trimmed = String(url || '').trim();
            if (/^(https?:|mailto:|tel:)/i.test(trimmed)) {
                return trimmed.replace(/"/g, '%22');
            }
        } catch (e) { /* noop */ }
        return '#';
    }
    
    function validateOutput(jsonString, fallback) {
        try {
            return JSON.parse(jsonString);
        } catch (e) {
            return fallback;
        }
    }
    
    function handleButtonState(button, isLoading) {
        var buttonText = button.find('.button-text');
        var loadingSpinner = button.find('.loading-spinner');
        
        if (isLoading) {
            button.prop('disabled', true);
            buttonText.fadeOut(200, function() {
                loadingSpinner.fadeIn(200);
            });
        } else {
            loadingSpinner.fadeOut(200, function() {
                buttonText.fadeIn(200);
            });
            button.prop('disabled', false);
        }
    }
    
    function submitContactForm() {
        $('#form-faq-contact').submit();
    }

    function getConversation() {
        var conversation = '';
        var chatMessages = $('#chat-messages');
        
        if (chatMessages.length === 0) {
            return conversation;
        }
        
        chatMessages.find('.ai-message').each(function() {
            var messageContent = $(this).find('.message-content p').text().trim();
            var isUser = $(this).hasClass('user-message');
            
            if (isUser) {
                conversation += 'user: ' + messageContent + '\n';
            } else {
                conversation += 'assistant: ' + messageContent + '\n';
            }
        });
        
        return conversation;
    }
    

    function initializeChat() {
        var chatInput = $('#chat-input');
        var chatSendBtn = $('#chat-send-btn');

        function sendMessage(){
            if (chatHasEnded) return;
            var message = chatInput.val().trim();
            if (message === '') return;
        
            chatInput.prop('disabled', true);
            chatSendBtn.prop('disabled', true);
            
            addChatMessage(message, true);
            chatInput.val('');
            
            sendMessageApi(message, function(response) {
                chatInput.prop('disabled', false);
                chatSendBtn.prop('disabled', false);
                chatInput.focus();
                
                if (response && response.success) {
                    var output = validateOutput(response.response, null);
                    if (output && output[0] && output[0].message_type) {
                        switch (output[0].message_type) {
                            case 'TRANSFER':
                                $('#conversation_summary').val(escapeBasicHtml(output[0].summary));
                                $('#conversation_history').val(escapeBasicHtml(getConversation()));                        

                                addChatMessage('Vou criar um protocolo para acompanhar seu caso. Um momento por favor.', false);
                                setTimeout(function() {
                                    addChatMessage('O chat foi finalizado. Obrigado pelo contato!', false);
                                    $('.chat-input-container').hide();
                                    chatHasEnded = true;
                                }, 1500);
                                setTimeout(submitContactForm, 3500);
                                break;
                            case 'RESOLVED':
                                addChatMessage(output[0].output, false);
                                $('.chat-input-container').hide();
                                chatHasEnded = true;
                                break;
                            case 'NORMAL':
                                addChatMessage(output[0].output, false);
                                break;
                        }    
                    } else {
                        addChatMessage('Desculpe, não consegui processar sua mensagem.', false);
                    }
                } else {
                    addChatMessage('Desculpe, não consegui processar sua mensagem.', false);
                }
            }, function(errorMsg) {
                chatInput.prop('disabled', false);
                chatSendBtn.prop('disabled', false);
                chatInput.focus();
                addChatMessage(errorMsg, false);
            });
        }
        
        chatSendBtn.click(sendMessage);
        
        chatInput.keyup(function(e) {
            if (e.which === 13) { // Enter key
                e.preventDefault();
                sendMessage();
            }
        });
        
        $('.mini-chat-support').on('shown', function() {
            chatInput.focus();
        });
    }
    
    function formatMarkdownMessage(text) {
        text = escapeBasicHtml(text);
        text = text.replace(/^### (.*)$/gm, '<h3>$1</h3>');
        text = text.replace(/^## (.*)$/gm, '<h2>$1</h2>');
        text = text.replace(/^# (.*)$/gm, '<h1>$1</h1>');
        text = text.replace(/\[([^\]]+)\]\(([^)]+)\)/g, function(_, label, url) {
            return '<a href="' + sanitizeUrl(url) + '" target="_blank" rel="noopener noreferrer nofollow">' + label + '</a>';
        });
        text = text.replace(/\*\*(?!\s)([^*]+?)\*\*/g, '<strong>$1</strong>');
        text = text.replace(/__(?!\s)([^_]+?)__/g, '<strong>$1</strong>');
        text = text.replace(/\B\*(?!\s)([^*]+?)\*\B/g, '<em>$1</em>');
        text = text.replace(/\B_(?!\s)([^_]+?)_\B/g, '<em>$1</em>');
        text = text.replace(/\n/g, '<br>');
        return text;
    }
    
    function typeHtmlSafely(messageId, content, delay) {
        var $target = $('#' + messageId + ' .message-content p');
        var $wrapper = $('<div>').html(content);
        var nodes = $wrapper.contents().toArray();
        var state = { 'i': 0 };
        var charCount = 0;
        
        function typeNode() {
            if (state['i'] >= nodes.length) return;
            var current = nodes[state['i']++];
            var isText = current.nodeType === Node.TEXT_NODE;
    
            if (isText) {
                var text = current.nodeValue;
                var localState = { 'j': 0 };
    
                (function typeChar() {
                    if (localState['j'] < text.length) {
                        $target.append(document.createTextNode(text.charAt(localState['j']++)));
                        charCount++;
                        
                        if (charCount % 20 === 0) {
                            scrollChatToBottom();
                        }
                        
                        setTimeout(typeChar, delay);
                    } else {
                        typeNode();
                    }
                })();
    
            } else {
                $target.append(current);
                typeNode();
            }
        }
    
        typeNode();
    }
    
    function scrollChatToBottom() {
        var chatMessages = $('#chat-messages');
        if (chatMessages.length > 0) {
            chatMessages.animate({
                scrollTop: chatMessages[0].scrollHeight
            }, 300);
        }
    }

    function addChatMessage(message, isUser) {
        var chatMessages = $('#chat-messages');
        if (chatMessages.length === 0) {
            setTimeout(function() { addChatMessage(message, isUser); }, 100);
            return;
        }
        var currentTime = new Date().toLocaleTimeString('pt-BR', {hour: '2-digit', minute: '2-digit'});
        if (!isUser) {
            var messageId = 'msg-' + Date.now() + '-' + Math.floor(Math.random()*10000);
            var messageHtml = '<div id="' + messageId + '" class="ai-message bot-message"><div class="message-content"><p></p><span class="message-time">' + currentTime + '</span></div></div>';
            chatMessages.append(messageHtml);
            scrollChatToBottom();
            var formattedMessage = formatMarkdownMessage(message);
            typeHtmlSafely(messageId, formattedMessage, 5);
        } else {
            var formattedMessage = escapeBasicHtml(message).replace(/\n/g, '<br>');
            var messageHtml = '<div class="ai-message user-message"><div class="message-content"><p>' + formattedMessage + '</p><span class="message-time">' + currentTime + '</span></div></div>';
            chatMessages.append(messageHtml);
            scrollChatToBottom();
        }
    }
    
    function sendMessageApi(message, onSuccess, onError) {
        var tempId = 'temp-pensando-msg';
        var formData = new FormData();
        formData.append('message', message);
        formData.append('YII_CSRF_TOKEN', $('[name="YII_CSRF_TOKEN"]').val());
        
        $.ajax({
            url: '/cms/faq/sendmessage/',
            method: 'POST',
            data: formData,
            processData: false,
            contentType: false,
            beforeSend: function(xhr) {
                setTimeout(function() {
                    var tempMessageHtml = '<div id="' + tempId + '" class="ai-message bot-message"><div class="message-content"><p><em>Escrevendo...</em></p><span class="message-time">' + new Date().toLocaleTimeString('pt-BR', {hour: '2-digit', minute: '2-digit'}) + '</span></div></div>';
                    $('#chat-messages').append(tempMessageHtml);
                    scrollChatToBottom();
                }, 1000);
            },
            success: function(data) {
                var response = data;
                if (typeof data === 'string') {
                    try {
                        response = JSON.parse(data);
                    } catch (e) {
                        if (onError) onError('Erro ao processar a resposta.');
                        return;
                    }
                }
                $('#' + tempId).remove();
                if (onSuccess) onSuccess(response);
            },
            error: function(xhr, status, error) {
                $('#' + tempId).remove();
                if (onError) onError('Erro de conexão. Tente novamente.');
            }
        });
    }
    
    function interceptContact() {
        var button = $("#agent-validate-button");
        var message = $('#fullMessage').val();
        var orderNumber = $('#orderNumber').val();

        if (orderNumber.trim() !== '') {
            message += "\n" + 'NUMERO DO PEDIDO: ' + orderNumber;
        }

        sendMessageApi(message, function(response) {
            handleButtonState(button, false);
            
            if (response && response.success) {
                var output = validateOutput(response.response, null);
                if (output && output[0] && output[0].message_type && output[0].message_type === 'NORMAL') {
                    $('.smart-email .mainContent .container').fadeOut(500, function() {
                        $('.mini-chat-support').fadeIn(500, function() {
                            initializeChat();
                            
                            $('html, body').animate({
                                scrollTop: 0
                            }, 300);

                            //Insert user message on chat
                            setTimeout(function() {
                                addChatMessage($('#message').val(), true);
                            }, 100);
                            
                            //Insert bot message on chat
                            setTimeout(function() {
                                addChatMessage(output[0].output, false);
                            }, 600);
                        });
                    });
                } else {
                    submitContactForm();
                }    
            } else {
                submitContactForm();
            }
        }, function(errorMsg) {
            handleButtonState(button, false);
            submitContactForm();
        });
    }
    
    window.interceptContact = interceptContact;
})();